import { Component } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';

@Component({
    selector: 'las-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false,
})
export class DashboardComponent {
    isAdmin: boolean = false;

    constructor(authService: AuthService) {
        this.isAdmin = authService.isAdmin();
    }
}
